import { merge } from '../../helper';

import addClass from '../../general/class/addClass';

import * as exElement from '../../utils/element';
import type { IElementConfig } from '../../utils/element/types';

// ----------------------------------------------------------------------------

export interface IProgressConfig extends IElementConfig {
    animated?: boolean;
    progressBar?: IElementConfig;
    striped?: boolean;
    width?: string;
}

export type TypeBuildReturn = {
    element: HTMLElement;
    elements: {
        element: HTMLElement;
        bar: HTMLElement;
    };
};

// ----------------------------------------------------------------------------

function create(config: IProgressConfig = {}): TypeBuildReturn {
    const defConfig: IProgressConfig = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build = {
        elements: {},
    } as TypeBuildReturn;

    // ------------------------------------------------------------------------

    // Create element (progress)
    const elProgress = exElement.create({
        merge: defConfig,
        class: {
            new: 'progress',
        },
        attr: {
            role: 'progressbar',
        },
    });
    build.elements.element = elProgress;
    build.element = elProgress;

    // Create element (progress bar)
    const elProgressBar = exElement.create({
        merge: defConfig.progressBar,
        class: {
            new: 'progress-bar',
        },
    });
    elProgress.appendChild(elProgressBar);
    build.elements.bar = elProgressBar;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // Methods
    methods(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build;
}

function settings(build: TypeBuildReturn, config: IProgressConfig = {}): void {
    const elements = build.elements;

    // If using width
    if (config.width != null) {
        elements.bar.style.width = config.width;
    }

    // If using striped
    if (config.striped === true) {
        addClass(elements.bar, 'progress-bar-striped');

        // Is using animated
        if (config.animated === true) {
            addClass(elements.bar, 'progress-bar-animated');
        }
    }
}

function methods(build: Record<string, any>, config: IProgressConfig = {}): void {
    const elements = build.elements;

    // Function Set Value
    const fnSetValue = function (value): any {
        elements.bar.style.width = value + '%';
        elements.bar.innerHTML = value + '%';
    };
    elements.element.setValue = fnSetValue;
    build.setValue = fnSetValue;
}

// ----------------------------------------------------------------------------

export { create };
